import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { hrefToSlug } from "../../utils/serviceRoutes";

const ServiceCard = ({
  id,
  href,
  isActive,
  index,
  category,
  isRecommended,
  title,
  description,
}) => {
  const { t, i18n } = useTranslation();
  const base = `serviceCatalog.${id}`;
  const cat = t(`${base}.category`);
  const ttl = t(`${base}.title`);
  const desc = t(`${base}.description`);
  const displayCategory = cat === `${base}.category` ? category : cat;
  const displayTitle = ttl === `${base}.title` ? title : ttl;
  const displayDescription =
    desc === `${base}.description` ? description : desc;

  const to = `/service/${hrefToSlug(href)}`;

  return (
    <Link
      to={to}
      id={id}
      dir={i18n.dir()}
      className={`services-picker__item slick-slide vh-services-slider__slide vh-pick-card ${
        isActive
          ? "slick-current slick-active vh-services-slider__slide--active"
          : ""
      } ${isRecommended ? "vh-pick-card--recommended" : ""}`}
      data-slick-index={index}
      aria-hidden={!isActive}
      tabIndex={isActive ? 0 : -1}
    >
      <span className="vh-pick-card__accent" aria-hidden="true" />
      <div className="vh-pick-card__shell">
        <div className="vh-pick-card__head">
          <span className="vh-pick-card__meta">{displayCategory}</span>
          {isRecommended ? (
            <span className="vh-pick-card__badge">
              {t("serviceCard.recommended")}
            </span>
          ) : null}
        </div>
        <h3 className="vh-pick-card__title title-h4">{displayTitle}</h3>
        <p className="vh-pick-card__desc description-n">{displayDescription}</p>
        <div className="vh-pick-card__footer">
          <span className="vh-pick-card__cta">{t("serviceCard.viewService")}</span>
          <span className="vh-pick-card__cta-icon" aria-hidden="true">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 10h12m0 0l-4.5-4.5M16 10l-4.5 4.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
